import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, of, tap } from 'rxjs';
import { ProjectStore } from '@frontend-site/shared/core';
import {
    DownloadEntityTemplateRequest,
    DownloadTmFile,
    DownloadTmFileRequest,
    DownloadTmFileResponse,
    DownloadTmFileType
} from '../entities';

@Injectable({
    providedIn: 'root'
})
export class DownloadTmFileService {
    constructor(private http: HttpClient, private readonly store: ProjectStore) {}

    downloadEntityTemplate(downloadAttachmentRequest: DownloadEntityTemplateRequest): Observable<DownloadTmFile> {
        return this.http.post<DownloadTmFileResponse>(`/rest/download/entityTemplate`, downloadAttachmentRequest).pipe(
            map((response) => {
                return { url: this.createBlobUrl(response.byteData), fileName: decodeURIComponent(response.fileName) };
            })
        );
    }

    downloadTmFile(
        type: DownloadTmFileType,
        guid?: string,
        temp?: boolean,
        entityId?: number,
        stepNum?: number,
        fileLink?: string
    ): Observable<DownloadTmFile> {
        const projectId = this.store.projectDetails?.projectId as number;
        const companyId = this.store.projectDetails?.companyId as number;
        const downloadAttachmentRequest: DownloadTmFileRequest = {
            guid,
            entityId,
            stepNum,
            fileLink,
            temp: temp,
            projectId,
            companyId,
            type: DownloadTmFileType[type]
        };

        return this.http.post<DownloadTmFileResponse>(`/rest/download/tmFile`, downloadAttachmentRequest).pipe(
            map((response) => {
                if (response.fileUrl) {
                    return { url: response.fileUrl, fileName: response.fileName };
                }
                return { url: this.createBlobUrl(response.byteData), fileName: decodeURIComponent(response.fileName) };
            })
        );
    }

    public downloadTMFileFromBrowser(
        type: DownloadTmFileType,
        guid?: string,
        temp?: boolean,
        entityId?: number,
        stepNum?: number,
        fileLink?: string
    ): Observable<void> {
        return this.downloadTmFile(type, guid, temp, entityId, stepNum, fileLink).pipe(
            tap((response) => {
                this.downloadFromBrowser(response.url, response.fileName);
            }),
            map(() => {
                of(null);
            })
        );
    }

    public downloadFromBrowser(fileUrl: string, fileName: string): void {
        const anchor = document.createElement('a');
        anchor.href = fileUrl;
        anchor.download = fileName;
        anchor.style.display = 'none';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    }

    public createBlobUrl(base64Data: string): string {
        const blob = this.base64ToBlob(base64Data);
        return window.URL.createObjectURL(blob);
    }

    private base64ToBlob(base64String: string): Blob {
        const binaryString = atob(base64String);
        const byteArray = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            byteArray[i] = binaryString.charCodeAt(i);
        }
        return new Blob([byteArray]);
    }
}
